import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { EventAdminSummaryDto, EventStatusEnum, EventSummaryDto, RegistrationHelper, typeSportEnumText } from '@aoe/client';
import { Store } from '@ngrx/store';
import { filter, take, tap } from 'rxjs';
import { EventService } from 'src/app/core/services/event.service';
import { EventAdminActions } from 'src/app/core/store/admin/event-admin/event-admin.actions';
import { selectEventAdminSelected } from 'src/app/core/store/admin/event-admin/event-admin.selector';
import { formatShortDate } from '../../../core/helpers/Date.helpers';
import { IconsEnum } from '../../enum/Icons.enum';

@Component({
  selector: 'aoe-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss'],
  standalone: false
})
export class EventCardComponent implements OnChanges {

  @Input()
  event!: EventSummaryDto | EventAdminSummaryDto;

  @Input()
  adminSide: boolean = false;

  icons = IconsEnum;
  private registrationHelper!: RegistrationHelper;

  public dateHelper = formatShortDate;

  constructor(
    private readonly store: Store,
    private readonly router: Router,
    private readonly eventService: EventService
  ) {
  }

  ngOnChanges(_changes: SimpleChanges): void {
    // if (changes['event'].currentValue)
    //   this.registrationHelper = new RegistrationHelper(this.event.registration);

  }

  get isEventVisible(): boolean {
    return 'isVisible' in this.event ? Boolean(this.event.isVisible) : false;
  }

  get hasRacesRegistred(): boolean {
    return true;
  }

  get pictureLink(): string {
    if (this.event.pictures)
      return this.eventService.getPictureLink(this.event.id);
    return '/assets/img/default_event_picture.png';
  }

  get typeOfSportLabel(): string {
    return typeSportEnumText(this.event.sport);
  }

  get linkToLive(): string {
    return `/${this.event.link}`
  }

  get isReady(): boolean {
    return !!this.event.link;
  }

  get eventColor(): string | null {
    return this.event.color ?? null;
  }

  get isLiveTrail(): string | null {
    return this.event.livetrail;
  }

  get isRegistrationOpen() {
    return this.registrationHelper?.isOpen;
  }

  // get registrationUrl() {
  //   return this.event.registration?.link;
  // }

  get buttonFollowLabel(): string {
    switch (this.event.timingStatus) {
      case EventStatusEnum.NOT_STARTED:
        return 'Consulter';

      case EventStatusEnum.IN_PROGRESS:
        return 'Live';

      case EventStatusEnum.FINISHED:
        return 'Résultats';

      default:
        return '';
    }
  }

  editEvent() {
    this.store.select(selectEventAdminSelected).pipe(
      filter(e => !!e),
      take(1),
      tap(event => this.router.navigate(['admin', 'evenement', event.id, 'informations-generales']))
    ).subscribe();
    this.store.dispatch(EventAdminActions.loadEventDetail({ payload: { id: this.event.id } }))
  }

  goToDashboard() {
    this.store.select(selectEventAdminSelected).pipe(
      filter(e => !!e),
      take(1),
      tap(event => this.router.navigate(['admin', 'evenement', event.id]))
    ).subscribe();
    this.store.dispatch(EventAdminActions.loadEventDetail({ payload: { id: this.event.id } }))
  }

  // get registrationUrl(): string | null {
  //   if (_.isNil(this.event.registration?.openDate) || _.isNil(this.event.registration?.closeDate))
  //     return null
  //   const today = new Date().getTime();
  //   const dateConditions = today > new Date(this.event.registration.openDate).getTime() && today < new Date(this.event.registration.closeDate).getTime();
  //   return this.event.registration?.link && dateConditions ? this.event.registration.link : null;
  // }

  deleteEvent() {
    // this.dialogService.openConfirmationModal('supEvent', {}).afterClosed().subscribe(res => {
    //   if (res)
    //     this.store.dispatch(eventActions['deleteEvent']({ payload: { id: this.event.id } }))
    // })
  }
}
